import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Client } from '../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { EnterValueDialogComponent } from '../../../../projects/kiene-core/src/lib/components/dialogs/enter-value-dialog/enter-value-dialog.component';
import {
    EnterValueInput,
    EnterValueResponse,
} from '../../../../projects/kiene-core/src/lib/components/dialogs/enter-value-dialog/enter-value-response';
import {
    PdfViewerDesktopService,
    PdfViewerDialogInput,
} from '../../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';
import { Tierarzt } from '../../../../projects/kiene-core/src/lib/components/tieraerzte/classes/tierarzt';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneBackendApiService } from '../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { HotKeyListDialogComponent } from '../../documents/abgabebeleg/hot-key-list-dialog/hot-key-list-dialog.component';
import { ArtikellisteAusfuellenDialogResult } from '../../documents/beleg-position/artikelliste-ausfuellen-dialog/artikelliste-ausfuellen-dialog';
import {
    Artikelliste,
    ArtikellisteArtikel,
    ArtikellisteAuswahlDialogResult,
} from '../../documents/beleg-position/artikelliste-auswahl-dialog/artikelliste-auswahl-dialog';
import { ArtikellisteAuswahlDialogComponent } from '../../documents/beleg-position/artikelliste-auswahl-dialog/artikelliste-auswahl-dialog.component';
import { HeimtierBeleg, HeimtierBelegArtikel, HeimtierBelegStatus } from '../heimtier-beleg';
import { Heimtier } from '../kalender/heimtier-kalender-eintrag';
import { HeimtiereService } from '../heimtiere.service';

@Component({
    selector: 'kiene-besuchs-detail-seite',
    templateUrl: './besuchs-detail-seite.component.html',
    styleUrls: ['./besuchs-detail-seite.component.scss'],
    host: { '(window:keydown)': 'checkForKeys($event)' },
})
export class BesuchsDetailSeiteComponent implements OnInit, OnChanges {
    public heimtierBeleg: HeimtierBeleg;
    kunde: Client;
    besuchsdatumCtrl = new FormControl(undefined, [Validators.required]);
    behandlungStartCtrl = new FormControl();
    behandlungEndeCtrl = new FormControl();
    arztCtrl = new FormControl(undefined, Validators.required);
    aerzte: Tierarzt[] = [];
    heimtier: Heimtier;
    belegValid = false;
    isSaving = false;
    selectedTabIndex: number = 0; // Standard-Tab
    protected readonly HeimtierBelegStatus = HeimtierBelegStatus;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly api: KieneBackendApiService,
        private readonly messageService: MessageService,
        private readonly heimtierService: HeimtiereService,
        private readonly localStorageService: LocalStorageService,
        private readonly dialog: MatDialog,
        private readonly pdfService: PdfViewerDesktopService,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
    ) {}

    ngOnInit(): void {
        const ht_beleg_id = this.route.snapshot.paramMap.get('id');
        if (!ht_beleg_id) {
            return;
        }
        const savedIndex = localStorage.getItem('selectedTabIndex');
        if (savedIndex !== null) {
            this.selectedTabIndex = +savedIndex;
        }
        this.loadHeimtierBeleg(Number.parseInt(ht_beleg_id));
        this.loadAerzte();

        this.arztCtrl.valueChanges.subscribe({
            next: arzt => {
                this.heimtierBeleg.tierarzt_id = arzt.tierarzt_id;
                this.updateBeleg();
            },
        });

        this.besuchsdatumCtrl.valueChanges.subscribe({
            next: datum => {
                this.heimtierBeleg.datum = datum;
                this.updateBeleg();
            },
        });

        this.behandlungStartCtrl.valueChanges.subscribe({
            next: start => {
                if (start) {
                    if (start.includes(':')) {
                        const time = start.split(':');
                        const seit = new Date(this.heimtierBeleg.datum);
                        seit.setHours(+time[0], +time[1]);
                        this.heimtierBeleg.behandlung_seit = seit;
                        this.updateBeleg();
                    }
                }
            },
        });

        this.behandlungEndeCtrl.valueChanges.subscribe({
            next: ende => {
                if (ende) {
                    if (ende.includes(':')) {
                        const time = ende.split(':');
                        const bis = new Date(this.heimtierBeleg.datum);
                        bis.setHours(+time[0], +time[1]);
                        this.heimtierBeleg.behandlung_bis = bis;
                        this.updateBeleg();
                    }
                }
            },
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['heimtierBeleg'] && this.heimtierBeleg) {
            this.initFormFields();
        }
    }

    public abschliessen(): void {
        this.isSaving = true;
        this.api.post(this.apiBaseUrl + 'heimtier_beleg/abschliessen.php', this.heimtierBeleg).subscribe({
            next: response => {
                this.heimtierBeleg = response;
                this.isSaving = false;

                const url = 'heimtier_beleg/read_or_mail_pdf.php';
                const params = new HttpParams().set('ht_beleg_id', this.heimtierBeleg.ht_beleg_id?.toString());
                const titel = 'Pflichtbeleg Heimtier';
                const sende_mail = true;

                const input = new PdfViewerDialogInput(url, params, titel, {
                    email: { sende_mail: sende_mail, kunde_id: this.heimtierBeleg.kunde_id },
                });
                this.pdfService.openPdfViewer(input);
            },
            error: err => {
                this.isSaving = false;
                this.messageService.errorMessage('Fehler beim Abschließen!', err);
            },
        });
    }

    public reload(): void {
        this.loadHeimtierBeleg(this.heimtierBeleg.ht_beleg_id);
    }

    onBelegValidationChange(isValid: boolean) {
        this.belegValid = isValid;
    }

    onTabChange(event: any) {
        this.selectedTabIndex = event.index;
        localStorage.setItem('selectedTabIndex', this.selectedTabIndex.toString());
    }

    setCurrentHeimtier(heimtier: Heimtier) {
        this.heimtier = heimtier;
    }

    private loadHeimtierBeleg(ht_beleg_id: number): void {
        let param = new HttpParams().set('ht_beleg_id', ht_beleg_id);
        this.api.get(this.apiBaseUrl + 'heimtier_beleg/read_one.php', param).subscribe({
            next: response => {
                this.heimtierBeleg = response;
                this.initFormFields();
                this.loadKunde();
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Laden des Belegs', err);
            },
        });
    }

    private loadAerzte(): void {
        this.api.getAll(this.apiBaseUrl + 'tierarzt/read.php').subscribe({
            next: data => {
                this.aerzte = data.records;
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Laden der Ärzte', err);
            },
        });
    }

    private loadKunde(): void {
        const params: HttpParams = new HttpParams().set('kunde_id', this.heimtierBeleg?.kunde_id);
        this.api.get(this.apiBaseUrl + 'heimtier_kunde/read_one.php', params).subscribe({
            next: data => {
                this.kunde = data;
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Laden des Kunden', err);
            },
        });
    }

    private setCurrentTierarzt() {
        if (this.heimtierBeleg?.tierarzt_id) {
            this.arztCtrl.setValue(
                this.aerzte.find(arzt => arzt.tierarzt_id === this.heimtierBeleg.tierarzt_id),
                { emitEvent: false },
            );
        }
    }

    private updateBeleg() {
        if (
            this.heimtierBeleg.status_id === HeimtierBelegStatus.ABGESCHLOSSEN ||
            this.heimtierBeleg.status_id === HeimtierBelegStatus.ERSTELLT
        ) {
            this.api.post(this.apiBaseUrl + 'heimtier_beleg/update.php', this.heimtierBeleg).subscribe({
                next: response => {
                    this.heimtierBeleg = response;
                },
                error: err => {
                    this.messageService.errorMessage('Fehler beim Speichern des Belegs', err);
                },
            });
        }
    }

    private initFormFields() {
        this.besuchsdatumCtrl.setValue(this.heimtierBeleg.datum, { emitEvent: false });
        this.behandlungStartCtrl.setValue(this.formatTime(this.heimtierBeleg.behandlung_seit), { emitEvent: false });
        if (this.heimtierBeleg.behandlung_bis) {
            this.behandlungEndeCtrl.setValue(this.formatTime(this.heimtierBeleg.behandlung_bis), { emitEvent: false });
        }
        if (this.heimtierBeleg?.status_id === 223) {
            this.behandlungStartCtrl.disable();
            this.behandlungEndeCtrl.disable();
        }
        this.setCurrentTierarzt();
    }

    private formatTime(date: Date): string {
        date = new Date(date);
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
    }

    rechnungErstellen() {
        this.heimtierService.rechnungErstellen(this.heimtierBeleg);
    }

    disabled() {
        return (
            this.isSaving ||
            this.arztCtrl.invalid ||
            this.besuchsdatumCtrl.invalid ||
            this.behandlungStartCtrl.invalid ||
            this.behandlungEndeCtrl.invalid
        );
    }

    setCurrentBeleg(event: HeimtierBeleg) {
        this.heimtierBeleg = event;
    }

    checkForKeys(keyEvent: KeyboardEvent) {
        // console.debug("Beleg Position keyEvents: " + keyEvent.code);
        if (keyEvent.altKey && keyEvent.code === 'KeyH') {
            this.artikellisteAuswaehlen();
        }
    }

    artikellisteAuswaehlen() {
        if (this.localStorageService.hasPermission(2681)) {
            this.dialog
                .open(ArtikellisteAuswahlDialogComponent, {})
                .afterClosed()
                .subscribe({
                    next: (result: ArtikellisteAuswahlDialogResult) => {
                        if (result?.confirm === true && result?.artikelliste) {
                            this.artikellisteAusfuellen(result.artikelliste);
                        }
                    },
                });
        }
    }

    artikellisteAusfuellen(artikelliste: Artikelliste) {
        const input = new ArtikellisteAusfuellenDialogResult();
        input.artikelliste = artikelliste;

        const evdInput = new EnterValueInput();
        evdInput.title = 'Artikelliste "' + artikelliste.listenname + '" ausfüllen';

        evdInput.text = null;
        evdInput.html = '<strong>Artikel:</strong><br/><br/>';
        artikelliste.artikel.forEach((art, idx) => {
            evdInput.html += idx + 1 + '. ' + art.artikel_me + ' (' + (art.tierart || '') + ')<br/><br/>';
        });
        evdInput.html += '<br/>Bitte Faktor für die Artikelliste eingeben.';

        evdInput.addInputValue('Faktor für Artikelliste', 'numeric', 1);

        this.dialog
            .open(EnterValueDialogComponent, { data: evdInput })
            .afterClosed()
            .subscribe({
                next: (result: EnterValueResponse) => {
                    if (result?.result) {
                        console.log('Artikelliste ausfüllen mit Faktor:', result.getValue(0));
                        this.alleArtikelAusListeHinzufuegen(input, result.getValue(0));
                    } else {
                        return;
                    }
                },
            });
    }

    alleArtikelAusListeHinzufuegen(input: ArtikellisteAusfuellenDialogResult, faktor?: number) {
        if (input?.artikelliste.artikel.length > 0) {
            input.artikelliste.artikel.forEach((position: ArtikellisteArtikel) => {
                let p = new HeimtierBelegArtikel();
                p.ht_beleg_id = this.heimtierBeleg.ht_beleg_id;
                p.artikel_id = position.artikel_id;
                p.artikel_me = position.artikel_me;
                p.indikation_id = position.indikation_id;
                p.diagnose = position.diagnose;
                p.heimtier_id = this.heimtier?.heimtier_id;
                p.name = this.heimtier.name;
                p.tierart_id = position.tierart_id;
                p.tierart = this.heimtier.tierart;
                p.tierrasse_id = this.heimtier.tierrasse_id;
                p.anwendungsdauer = position.anwendungsdauer;
                p.abgabeundbehandlung = position.abgabeundbehandlung;
                p.dosierung = position.dosierung;
                p.anwendung_id = position.anwendung_id;
                p.anwendung = position.anwendung;
                p.behandlung = position.behandlung;
                p.faktor = faktor || 1;
                p.artikelmenge = 1;
                p.koerpergewicht = position.koerpergewicht_tierart;
                p.dosierung_txt = position.dosierung_txt;
                p.verpackungsmenge = position.verpackungsmenge;
                p.dosierung_fix = position.dosierung_fix;

                this.heimtierBeleg.positionen.push(p);
            });
            this.updateBeleg();
        } else {
            this.messageService.errorMessage('Keine Artikel ausgewählt.', undefined);
        }
    }

    openHotKeyDialog() {
        this.dialog.open(HotKeyListDialogComponent, { data: {}, minWidth: '400px' });
    }
}
